(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_megamenu-featured"] && !Shopify.designMode) return;
  try {
    // Theme Editor affordance: selecting a megamenu block in the sidebar opens
  // its (otherwise hover-only) dropdown so it can be seen while editing.
  if (window.Shopify && window.Shopify.designMode && !window.__alegriaMegamenuEditorBound) {
    window.__alegriaMegamenuEditorBound = true;
    document.addEventListener('shopify:block:select', (event) => {
      const submenu = event.target.closest('.menu-list__submenu');
      if (submenu) submenu.classList.add('menu-list__submenu--editor-open');
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const submenu = event.target.closest('.menu-list__submenu');
      if (submenu) submenu.classList.remove('menu-list__submenu--editor-open');
    });
  }
  } catch(e) { console.error(e); }
})();

})();
